import { Dispatch, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';

import { cn, getPathToTitleObj } from 'utils';
import { MenuIcon } from 'assets/svgs';

interface Props {
  setIsSidebarOpen: Dispatch<SetStateAction<boolean>>;
}

const Header = ({ setIsSidebarOpen }: Props) => {
  const { pathname } = useLocation();
  const pathToTitleObj = getPathToTitleObj();

  function onClickOpenSidebar() {
    setIsSidebarOpen(true);
  }

  return (
    <header
      className={cn(
        'flex w-full flex-row items-center gap-2 overflow-hidden border-b border-border-dimmed p-3',
        'md:mb-2 md:h-12 md:border-none',
        { 'md:hidden': pathToTitleObj[pathname]?.isHeaderHidden }
      )}
    >
      <button
        type="button"
        className={cn(
          'flex h-6 w-6 flex-row items-center justify-center rounded border border-border-primary bg-button-bg_secondary text-button-text_secondary',
          'md:hidden'
        )}
        onClick={onClickOpenSidebar}
      >
        <MenuIcon />
      </button>
      <h1 className="flex-1 text-header font-semibold md:hidden">{pathToTitleObj[pathname]?.title ?? ''}</h1>
    </header>
  );
};

export default Header;
